// extracted by mini-css-extract-plugin
module.exports = {"faq":"faq_faq__NvIwE","faqContainer":"faq_faqContainer__WxIm8","title":"faq_title__JpbpK","description":"faq_description__j40Dm","list":"faq_list__Dfs_d"};